/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { platform } from 'network-utils';

const userContentApi = platform.learningPanel.userContentAPIs;

export const getPrimaryCourseData = 'user-content-primary-course-data';
export const getPrimaryCourseMetadata = 'user-content-primary-course-metadata';
export const getAssignedContentData = 'user-content-assigned-content-data';

export const useGetPrimaryCourseData = (userUuid?: string) => {
    return useQuery([getPrimaryCourseData, userUuid], () => userContentApi.getPrimaryCourseData(), {
        enabled: Boolean(userUuid)
    });
};

export const useGetPrimaryCourseMetadata = (userUuid?: string) => {
    return useQuery([getPrimaryCourseMetadata, userUuid], () => userContentApi.getPrimaryCourseMetadata(), {
        enabled: Boolean(userUuid)
    });
};

export const useGetAssignedContentData = (userUuid?: string) => {
    return useQuery([getAssignedContentData, userUuid], () => userContentApi.getAssignedContentData(), {
        enabled: Boolean(userUuid)
    });
};
